import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import { productStatusOptions } from './constants'

const ProductStatusFilter = ({ onChange, value }) => {
  const { t } = useTranslation()

  const getProductStatusOptions = () => productStatusOptions.map(o => ({ ...o, label: t(o.label) }))

  return (
    <ComboBox
      label={t('Estado del producto')}
      menuItems={getProductStatusOptions()}
      handleChange={e => onChange(e.target.value)}
      value={value}
      fullWidth
    />
  )
}

export default ProductStatusFilter
